let Progress = {
    init: () => {
        if ($('.progress-ring').length) Progress.initProgressRings();
    },

    initProgressRings: () => {
        let circle = document.querySelectorAll('.progress-ring-circle');

        circle.forEach(circle => {
            let radius = circle.r.baseVal.value,
                circumference = radius * 2 * Math.PI;

            circle.style.strokeDasharray = `${circumference} ${circumference}`;
            circle.style.strokeDashoffset = `${circumference}`;
            circle.style.strokeDashoffset = circumference - circle.dataset.progress / 100 * circumference;
        })
    }
};

export default Progress;
